import * as React from 'react';
import { AnimatePresence } from 'motion/react';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import { CheckoutForm } from '../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../slots/forms/form-context.js';
import '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../state.js';
import { updateShippingDetails } from '../actions.js';
import { HighlightedForm } from '../components/HighlightedForm.js';
import { getCompany, getCompanyFormData } from '../selectors.js';

const CompanyFormContainer = ()=>{
    const isCompanyFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Company);
    const companyDetails = useSelector(getCompany);
    const dispatch = useDispatch();
    const companyFormInitialData = useSelector(getCompanyFormData);
    const handleChange = React.useCallback((formData)=>{
        dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch
    ]);
    if (!isCompanyFormAvailable) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, Boolean(companyDetails) && /*#__PURE__*/ React.createElement(HighlightedForm, {
        key: "company-highlight",
        className: "checkout-step__highlight"
    }, /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "company",
        "data-t": "company",
        initialFormState: companyFormInitialData,
        onChange: handleChange
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.Company
    }))));
};

export { CompanyFormContainer };
//# sourceMappingURL=CompanyFormContainer.js.map
